import React from 'react';
import { useLoading } from '../../context/LoadingContext';
import logoDark from '../../assets/images/logo-dark.png';
import logoLight from '../../assets/images/logo-light.png';
import './LogoLoader.scss';

const LogoLoader = () => {
  const { isLoading, loadingMessage } = useLoading();

  // Try to get theme, fallback to light if not available
  let isDark = false;
  try {
    const themeAttr = document.body.getAttribute('data-theme');
    isDark = themeAttr === 'dark';
  } catch (e) {
    isDark = false;
  }

  // Don't render anything if not loading
  if (!isLoading) {
    return null;
  }

  // Use light logo on dark background, dark logo on light background
  const logo = isDark ? logoLight : logoDark;

  return (
    <div className={`logo-loader-overlay ${isDark ? 'dark' : 'light'}`}>
      <div className="logo-loader-container">
        <div className="logo-wrapper">
          <img src={logo} alt="Loading..." className="logo-image" />
          <div className="pulse-ring"></div>
          <div className="pulse-ring delay-1"></div>
          <div className="pulse-ring delay-2"></div>
        </div>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        {loadingMessage && (
          <p className="loading-message">{loadingMessage}</p>
        )}
      </div>
    </div>
  );
};

export default LogoLoader;
